export default __webpack_public_path__ + "static/media/airplane-green.c520bdb3.svg";